module.exports = __webpack_public_path__ + "media/images/favicons/icon-48x48-83ef887f8fc5562f04d02a1ee0afa4ac.png";